import React, {useEffect, useRef, useState} from "react";
import "./ModalForms.css";
import ReactDOM from "react-dom";
import useAxiosPrivate from "../../context/useAxiosPrivate";
import {Modal, Autocomplete, Button, CircularProgress, TextField, createFilterOptions} from '@mui/material';

import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ruRU } from '@mui/x-date-pickers/locales';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/ru';
import { BarChart, Line, Label, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';


const portal = document.getElementById('portal');


export const ModalForms = ({
                             createDate,
                             createDateOnly,
                             userActivityData,
                             getFactories,
                             factories,
                             modalType,
                             setModalType,
                             companies,
                             currentFactoryData,
                             getCompanies,
                             currentFactory,
                             setCurrentFactory,
                             getUsersByFactoryId,
                             localId,
                             rowData,
                              userRole
}) => {

  const axiosPrivate = useAxiosPrivate();
  const chooseModal = {
    addFactory: modalType === 'addFactory',
    editFactory: modalType === 'editFactory',
    addCompany: modalType === 'addCompany',
    addUser: modalType === 'addUser',
    editCompany: modalType === 'editCompany',
    editUser: modalType === 'editUser',
    activity: modalType === 'activity',
    sendNotifications : modalType === 'factoryNotify',
    factoryActivity : modalType === 'factoryActivity'
  }

  const platformsList = [
    {platformName: "---", platformId: "null"},
    {platformName: "IOS", platformId: "ios"},
    {platformName: "MacOS", platformId: "macos"},
    {platformName: "Android", platformId: "android"},
    {platformName: "Desktop", platformId: "desktop"},
  ];



  const updateTableData = () => {
    cancel();
    getUsersByFactoryId();
    getCompanies();
  }

  const cancel = () => {
    setModalType('');
  }

  const AddFactory = ({cancel, setCurrentFactory, factories, currentFactory}) => {
    const [factoryName, setFactoryName] = useState('');
    const [personName, setPersonName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [buttonSaveIsActive, setButtonSaveIsActive] = useState(false);

    useEffect(() => {
      ( factoryName === '' || personName === '' || phoneNumber === '') && setButtonSaveIsActive(false)
      factoryName && personName && phoneNumber !== '' && setButtonSaveIsActive(true)
    }, [factoryName, personName, phoneNumber]);

    const confirmAddFactory = (event) => {
      event.preventDefault();
      addNewFactoryData();
      cancel();
    }
    const addNewFactoryData = async () => {
      const newFactory = {
        factory: factoryName,
        phone: phoneNumber,
        contact: personName,
      }

      await axiosPrivate.post('/Users/Factory', newFactory)
        .then((res) => {
          getFactories();
          updateTableData();
        })
        .catch(e => {
          const data = e.response.data.message;
          'factory' in data
            ? alert(data.factory[0])
            : alert(data)
        });
    }

    return (
      <form id="form-add-factory" onSubmit={confirmAddFactory} className="modal-form">
        <h1  className="form-header">ДОБАВИТЬ ФАБРИКУ</h1>

        <label id="company-name" className="form-label">Введите название</label>
        <input
          id="company-name"
          type="text"
          autoFocus={true} required={true}
          className="form-input"
          value={factoryName}
          onChange={(event) => {
            setFactoryName(event.target.value)
          }}
        />

        <label id="person-name" className="form-label">ФИО</label>
        <input
          id="person-name"
          type="text"
          className="form-input"
          value={personName}
          onChange={(event) => {
            setPersonName(event.target.value)
          }}
        />

        <label id="phone-number" className="form-label">Номер телефона</label>
        <input
          id="phone-number"
          className="form-input form-input_last-input"
          type="tel"
          value={phoneNumber}
          onChange={(event) => {
            setPhoneNumber(event.target.value)
          }}
        />

        <div className="form-controls">
          <button type="button" className="form-button" onClick={cancel}>отменить</button>
          <button type="submit" className="form-button" disabled={!buttonSaveIsActive}
          style={buttonSaveIsActive ? {} : {color: "grey", borderColor: "grey"}}>сохранить</button>
        </div>
      </form>
    )
  }


  const EditFactory = ({setCurrentFactory, currentFactory, cancel, currentFactoryData}) => {
    const [factoryName, setFactoryName] = useState(`${currentFactoryData[0].factory}`);
    const [personName, setPersonName] = useState(`${currentFactoryData[0].contact}`);
    const [phoneNumber, setPhoneNumber] = useState(`${currentFactoryData[0].phone}`);
    const [buttonSaveIsActive, setButtonSaveIsActive] = useState(false);


    const confirmEditFactory = (event) => {
      event.preventDefault();
      EditFactoryData();
      cancel();
    }
    const EditFactoryData = async () => {
      const newFactoryData = {
        name: factoryName,
        phone: phoneNumber,
        contact: personName,
      }

      await axiosPrivate.put(`/Users/UpdateFactory/${currentFactory}`, newFactoryData)
        .then((res) => {
          getFactories();
          updateTableData();
        })
        .catch(e => {
          const data = e.response.data.message;
          'factory' in data
            ? alert(data.factory[0])
            : alert(data)
        });
    }

    const deleteFactory = async () => {
      await axiosPrivate.delete(`/Users/DeleteFactory/${currentFactory}`)
        .then((res) => {
          getFactories();
          updateTableData();
        })
        .catch(e => {
          const data = e.response.data.message;
          'factory' in data
          ? alert(data.factory[0])
            : alert(data.company[0])
        });
    }

    return (
      <form id="form-edit-factory" onSubmit={confirmEditFactory} className="modal-form">
        <h1  className="form-header">ФАБРИКА</h1>

        <label id="company-name" className="form-label">Название фабрики</label>
        <input
          id="factory-name"
          autoFocus={true}
          type="text"
          className="form-input"
          value={factoryName}
          onChange={(event) => {
            setFactoryName(event.target.value)
            event.target.value !== '' ? setButtonSaveIsActive(true) : setButtonSaveIsActive(false)
          }}
        />

        <label id="person-name" className="form-label">ФИО</label>
        <input
          id="person-name"
          type="text"
          className="form-input"
          value={personName}
          onChange={(event) => {
            setPersonName(event.target.value)
            event.target.value !== '' ? setButtonSaveIsActive(true) : setButtonSaveIsActive(false)
          }}
        />

        <label id="phone-number" className="form-label">Номер телефона</label>
        <input
          id="phone-number"
          className="form-input form-input_last-input"
          type="tel"
          value={phoneNumber}
          onChange={(event) => {
            setPhoneNumber(event.target.value)
            event.target.value !== '' ? setButtonSaveIsActive(true) : setButtonSaveIsActive(false)
          }}
        />


        <div className="form-controls">
          <button type="button" className="form-button" onClick={deleteFactory}>удалить</button>
          <button type="button" className="form-button" onClick={cancel}>отменить</button>
          <button type="submit" className="form-button" disabled={!buttonSaveIsActive}
                  style={buttonSaveIsActive ? {} : {color: "grey", borderColor: "grey"}}>сохранить</button>
        </div>
      </form>
    )
  }



  const AddCompany = ({cancel}) => {
    const [companyName, setCompanyName] = useState('');
    const [personName, setPersonName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [buttonSaveIsActive, setButtonSaveIsActive] = useState(false);

    useEffect(() => {
      ( companyName === '' || personName === '' || phoneNumber === '') && setButtonSaveIsActive(false)
      companyName && personName && phoneNumber !== '' && setButtonSaveIsActive(true)
    }, [companyName, personName, phoneNumber]);
    const confirmAddCompany = (event) => {
      event.preventDefault();
      addNewCompanyData();
      cancel();
    }
    const addNewCompanyData = async () => {
      const newCompany = {
        company: companyName,
        phone: phoneNumber,
        contact: personName,
        factoryId: currentFactory,
      }

      await axiosPrivate.post('/Users/Company', newCompany)
        .then((res) => {
          updateTableData();
        })
        .catch(e => {
          const data = e.response.data.message;
          'company' in data
            ? alert(data.company[0])
            : alert(data)
        });
    }

    return (
      <form id="form-add-company" onSubmit={confirmAddCompany} className="modal-form">
        <h1  className="form-header">ДОБАВИТЬ КОМПАНИЮ</h1>

        <label id="company-name" className="form-label">Введите название</label>
        <input
          id="company-name"
          type="text"
          autoFocus={true} required={true}
          className="form-input"
          value={companyName}
          onChange={(event) => {
            setCompanyName(event.target.value)
          }}
        />

        <label id="person-name" className="form-label">ФИО</label>
        <input
          id="person-name"
          type="text"
          className="form-input"
          value={personName}
          onChange={(event) => {
            setPersonName(event.target.value)
          }}
        />

        <label id="phone-number" className="form-label">Номер телефона</label>
        <input
          id="phone-number"
          className="form-input form-input_last-input"
          type="tel"
          value={phoneNumber}
          onChange={(event) => {
            setPhoneNumber(event.target.value)
          }}
        />


        <div className="form-controls">
          <button type="button" className="form-button" onClick={cancel}>отменить</button>
          <button type="submit" className="form-button" disabled={!buttonSaveIsActive}
                  style={buttonSaveIsActive ? {} : {color: "grey", borderColor: "grey"}}>сохранить</button>
        </div>
      </form>
    )
  }



  const EditCompany = ({companies, cancel, localId, rowData}) => {
    const [companyName, setCompanyName] = useState(`${rowData[localId].companyName}`)
    const [personName, setPersonName] = useState(`${rowData[localId].contactFullName}`);
    const [phoneNumber, setPhoneNumber] = useState(`${rowData[localId].phoneNumber}`);
    const [buttonSaveIsActive, setButtonSaveIsActive] = useState(false);
    const [currentCompanyData, setCurrentCompanyData] = useState([])

    useEffect(() => {
      setCurrentCompanyData(companies.filter((company) => {
        return rowData[localId].companyName === company.company
      }))
    }, []);

    const confirmEditCompany = (event) => {
      event.preventDefault();
      EditCompanyData();
      cancel();
    }
    const EditCompanyData = async () => {
      const newCompanyData = {
        name: companyName,
        phone: phoneNumber,
        contact: personName,
      }

      await axiosPrivate.put(`/Users/UpdateCompany/${currentCompanyData[0].id}`, newCompanyData)
        .then((res) => {
          updateTableData();
        })
        .catch(e => {
          const data = e.response.data.message;
          'company' in data
            ? alert(data.company[0])
            : alert(JSON.stringify(e.response.data.message))
        });
    }

    const deleteCompany = async () => {
      await axiosPrivate.delete(`/Users/DeleteCompany/${currentCompanyData[0].id}`)
        .then((res) => {
          updateTableData();
        })
        .catch(e => {
          const data = e.response.data.message;
          'company' in data
            ? alert(data.company[0])
            : alert(JSON.stringify(e.response.data.message))
        });
    }

    return (
      <form id="form-edit-company" onSubmit={confirmEditCompany} className="modal-form">
        <h1  className="form-header">КОМПАНИЯ</h1>

        <label id="company-name" className="form-label">Название компании</label>
        <input
          id="company-name"
          autoFocus={true}
          type="text"
          className="form-input"
          value={companyName}
          onChange={(event) => {
            setCompanyName(event.target.value)
            event.target.value !== '' ? setButtonSaveIsActive(true) : setButtonSaveIsActive(false)
          }}
        />

        <label id="person-name" className="form-label">ФИО</label>
        <input
          id="person-name"
          type="text"
          className="form-input"
          value={personName}
          onChange={(event) => {
            setPersonName(event.target.value)
            event.target.value !== '' ? setButtonSaveIsActive(true) : setButtonSaveIsActive(false)
          }}
        />

        <label id="phone-number" className="form-label">Номер телефона</label>
        <input
          id="phone-number"
          className="form-input form-input_last-input"
          type="tel"
          value={phoneNumber}
          onChange={(event) => {
            setPhoneNumber(event.target.value)
            event.target.value !== '' ? setButtonSaveIsActive(true) : setButtonSaveIsActive(false)
          }}
        />


        <div className="form-controls">
          <button type="button" className="form-button" onClick={deleteCompany}>удалить</button>
          <button type="button" className="form-button" onClick={cancel}>отменить</button>
          <button type="submit" className="form-button" disabled={!buttonSaveIsActive}
                  style={buttonSaveIsActive ? {} : {color: "grey", borderColor: "grey"}}>сохранить</button>
        </div>
      </form>
    )
  }

  const EditUser = ({cancel, localId, rowData}) => {
    const [chosenCompany, setChosenCompany] = useState(`${rowData[localId].userCompany.split('/')[0]}`);
    const [userName, setUserName] = useState(`${rowData[localId].userName}`);
    const [userAddress, setUserAddress] = useState(`${rowData[localId].userAddress}`);
    const [deviceToken, setDeviceToken] = useState(`${rowData[localId].keyLicense}`);
    const [chosenPlatform, setChosenPlatform] = useState(`${rowData[localId].userPlatform}`);
    const [userPlatform, setUserPlatform] = useState([]);
    const [userDescription, setUserDescription] = useState(`${rowData[localId].description}`)
    const [dateEndLicense, setDateEndLicense] = useState(dayjs(`${rowData[localId].finishLicense}`))
    const [dateStartLicense, setDateStartLicense] = useState(dayjs(`${rowData[localId].startLicense}`))
    const [cleared, setCleared] = useState(false);
    const [buttonSaveIsActive, setButtonSaveIsActive] = useState(false);

    useEffect(() => {
      getPlatformSelectOptions();
    }, []);

    useEffect(() => {
      if (cleared) {
        const timeout = setTimeout(() => {
          setCleared(false);
        }, 1500);

        return () => clearTimeout(timeout);
      }
      return () => {};
    }, [cleared]);

    const getPlatformSelectOptions = () => {
      const options = platformsList.map((platform, index) => {
        return <option
          className="distributors-factories__option"
          key={index}
          value={platform.platformId}
          label={platform.platformName}>
        </option>
      })
      setUserPlatform(options)
    }

    const deleteUser = async () => {
      await axiosPrivate.delete(`/Users/${rowData[localId].userId}`)
        .then((res) => {
          updateTableData();
        })
        .catch(e => {
          alert(JSON.stringify(e.response.data.message));
        });
    }

    const resetDeviceUniqueKey = async () => {
      await axiosPrivate.get(`/UserAdministration/ResetDeviceUniqueKey/${rowData[localId].userId}`)
        .then((res) => {
          if (res.statusText === 'OK') {
            alert('Success!');
          }
        })
        .catch(e => {
          alert(JSON.stringify(e.response.data.message));
        });
    }
    const confirmEditUser = (event) => {
      event.preventDefault();
      EditUserData();
      cancel();
    }
    const EditUserData = async () => {
      const newUserData = {
        name: userName,
        address: userAddress,
        email: 'email',
        description: userDescription,
        deviceToken: deviceToken,
        dateStartLicense: dateStartLicense === null ? null : dateStartLicense.format(),
        dateEndLicense: dateEndLicense === null ? null : dateEndLicense.format(),
        platform: chosenPlatform,
      };


    await axiosPrivate.put(`/Users/${rowData[localId].userId}`, newUserData)
      .then((res) => {
        updateTableData();
      })
      .catch(e => {
        const data = e.response.data.message;
        'Name' in data && alert(data.Name[0])

        'DeviceToken' in data && alert(data.DeviceToken[0])
      });
  }

    return (
      <form id="form-edit-user" onSubmit={confirmEditUser} className="modal-form">
        <h1  className="form-header">КОМПЬЮТЕР</h1>

        <label id="company-name" className="form-label">Компания</label>
        <input
          disabled={true}
          id="company-name"
          type="text"
          className="form-input"
          defaultValue={rowData[localId].userCompany}
        />

        <label id="user-name" className="form-label">Введите название компьютера</label>
        <div className="form-input-container">
          <span className="form-input-container-span">{chosenCompany}</span>
          <input
            id="computer-name"
            className="form-input-container-input"
            type="text"
            value={userName}
            required={true}
            autoFocus={true}
             onChange={(event) => {
               setUserName(event.target.value)
               event.target.value !== '' ? setButtonSaveIsActive(true) : setButtonSaveIsActive(false)
             }}/>
        </div>

        <label id="device-token-number" className="form-label">Ключ</label>
        <input
          id="device-token-number"
          className="form-input"
          type="text"
          autoFocus={true}
          value={deviceToken}
          onChange={(event) => {
            setDeviceToken(event.target.value)
            event.target.value !== '' ? setButtonSaveIsActive(true) : setButtonSaveIsActive(false)
          }}
        />

        <label id="address" className="form-label">Адрес</label>
        <input
          id="address"
          className="form-input"
          type="text"
          value={userAddress}
          onChange={(event) => {
            setUserAddress(event.target.value)
            event.target.value !== '' ? setButtonSaveIsActive(true) : setButtonSaveIsActive(false)
          }}
        />

        <label id="platform-name" className="form-label">Выберите платформу</label>
        <select id="platform-name"
                className="form-select"
                value={chosenPlatform}
                onChange={(event) => {
                  setChosenPlatform(event.target.value);
                  setButtonSaveIsActive(true);
                }}
        >
          {userPlatform}
        </select>

        <label id="description" className="form-label">Примечание</label>
        <input
          id="description"
          className="form-input"
          type="text"
          value={userDescription}
          onChange={(event) => {
            setUserDescription(event.target.value)
            event.target.value !== '' ? setButtonSaveIsActive(true) : setButtonSaveIsActive(false)
          }}
        />

        <label id="start-license" className="form-label">Начало лицензии</label>
        <LocalizationProvider
          style={{width: "100%", marginBottom: "2vw"}}
          dateAdapter={AdapterDayjs}
          adapterLocale="ru"
          localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <DatePicker
            sx={{boxSizing: "border-box", width: "100%", border: "0.15vw solid grey", borderRadius: "8px", marginBottom: "3.5vw",
              "& .MuiInputBase-input": {fontSize: "2vw", color: "grey", padding: "0 0 0 0.5vw"},
              "& .MuiButtonBase-root-MuiPickersDay-root": {fontSize: "2vw", color: "red"},
            }}
            id={"finish-license"}
            value={dateStartLicense}
            onChange={(newValue) => {
              newValue !== dateStartLicense && newValue !== null  ? setButtonSaveIsActive(true) : setButtonSaveIsActive(false)
              setDateStartLicense(newValue)
            }}

            disablePast
            slotProps={{
              field: { clearable: true, onClear: () => setCleared(true)},
            }}
          />
        </LocalizationProvider>

        <label id="finish-license" className="form-label">Конец лицензии</label>
        <LocalizationProvider
          style={{width: "100%", marginBottom: "2vw"}}
          dateAdapter={AdapterDayjs}
          adapterLocale="ru"
          localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <DatePicker
            sx={{boxSizing: "border-box", width: "100%", border: "0.15vw solid grey", borderRadius: "8px", marginBottom: "3.5vw",
              "& .MuiInputBase-input": {fontSize: "2vw", color: "grey", padding: "0 0 0 0.5vw"},
              "& .MuiButtonBase-root-MuiPickersDay-root": {fontSize: "2vw", color: "red"},
            }}
            id={"finish-license"}
            value={dateEndLicense}
            onChange={(newValue) => {
              newValue !== dateEndLicense && newValue !== null  ? setButtonSaveIsActive(true) : setButtonSaveIsActive(false)
              setDateEndLicense(newValue)
            }}

            disablePast
            slotProps={{
              field: { clearable: true, onClear: () => setCleared(true)},
            }}
          />
        </LocalizationProvider>

        <div className="form-controls">
          <button type="button" className="form-button" onClick={resetDeviceUniqueKey}>Отвязать ключ</button>
          {rowData[localId].userName !== 'admin' &&
            <button type="button" className="form-button" onClick={deleteUser}>удалить</button>}
          <button type="button" className="form-button" onClick={cancel}>отменить</button>
          <button type="submit" className="form-button" disabled={!buttonSaveIsActive}
                  style={buttonSaveIsActive ? {} : {color: "grey", borderColor: "grey"}}>сохранить</button>
        </div>
      </form>
    )
  }

  const AddUser = ({companies, rowData, cancel}) => {
    const [chosenCompany, setChosenCompany] = useState(`${rowData[0].companyName}`);
    const [computerName, setComputerName] = useState('');
    const [computerAddress, setComputerAddress] = useState('');
    const [selectOptions, setSelectOptions] = useState([]);
    const [deviceToken, setDeviceToken] = useState('');
    const [userDescription, setUserDescription] = useState('');
    const [buttonSaveIsActive, setButtonSaveIsActive] = useState(false);
    const [userPlatform, setUserPlatform] = useState([]);
    const [chosenPlatform, setChosenPlatform] = useState(platformsList[0].platformName);

    useEffect(() => {
      getSelectOptions();
      getPlatformSelectOptions();
    }, []);

    useEffect(() => {
     ( computerName === '' || deviceToken === '' || userDescription === '') && setButtonSaveIsActive(false)
      computerName && deviceToken && userDescription !== '' && setButtonSaveIsActive(true)
    }, [ computerName, deviceToken, userDescription]);

    const getSelectOptions = () => {
      const selectData = rowData.filter((row) => {
        return Number.isInteger(row.tableId)
      })

      const options = selectData.map((company) => {
        return <option
          className="distributors-factories__option"
          key={company.tableId}
          value={company.companyName}
          label={company.companyName}>
        </option>
      })
      setSelectOptions(options)
    }

    const getPlatformSelectOptions = () => {
      const options = platformsList.map((platform, index) => {
        return <option
          className="distributors-factories__option"
          key={index}
          value={platform.platformId}
          label={platform.platformName}>
        </option>
      })
      setUserPlatform(options)
    }

    const confirmAddUser = (event) => {
      event.preventDefault();
      addNewUserData();
      cancel();
    }

    const addNewUserData = async () => {
      const newUser = {
        password: 'password',
        name: computerName,
        address: computerAddress,
        companyName: chosenCompany,
        description: userDescription,
        deviceToken: deviceToken,
        platform: chosenPlatform,
      };


      await axiosPrivate.post('/Users', newUser)
        .then((res) => {
          updateTableData();
        })
        .catch(e => {
          const data = e.response.data.message;
          'Name' in data && alert(data.Name[0])

          'DeviceToken' in data && alert(data.DeviceToken[0])
        });
    }

    return (
      <form id="form-add-user" onSubmit={confirmAddUser} className="modal-form">
        <h1  className="form-header">ДОБАВИТЬ КОМПЬЮТЕР В ИМЕЮЩУЮСЯ КОМПАНИЮ</h1>

        <label id="company-name" className="form-label">Выберите компанию</label>
        <select required={true}
                autoFocus={true}
                id="company-name"
                className="form-select"
                value={chosenCompany}
                onChange={(event) => setChosenCompany(event.target.value)}
        >
          {selectOptions}
          {/*{*/}
          {/*  companies !== null && companies.map((company) => {*/}
          {/*    return <option*/}
          {/*      className="distributors-factories__option"*/}
          {/*      key={company.id}*/}
          {/*      value={company.company}*/}
          {/*      label={company.company}>*/}
          {/*    </option>*/}
          {/*  })*/}
          {/*}*/}
        </select>

        <label id="computer-name" className="form-label">Введите название компьютера</label>
        <div className="form-input-container">
          <span className="form-input-container-span">{chosenCompany}</span>
          <input id="computer-name" className="form-input-container-input" type="text" value={computerName} required={true}
           onChange={(event) => {
             setComputerName(event.target.value)
           }}/>
        </div>

        <label id="key-license" className="form-label">Ключ</label>
        <input
          id="key-license"
          className="form-input"
          type="tel"
          value={deviceToken}
          onChange={(event) => {
            setDeviceToken(event.target.value)
          }}
        />

        <label id="address" className="form-label">Адрес</label>
        <input
          id="address"
          className="form-input form-input_last-input"
          type="text"
          value={computerAddress}
          onChange={(event) => {
            setComputerAddress(event.target.value)
          }}
        />

        <label id="platform-name" className="form-label">Выберите платформу</label>
        <select id="platform-name"
                className="form-select"
                value={chosenPlatform}
                onChange={(event) => setChosenPlatform(event.target.value)}
        >
          {userPlatform}
        </select>

        <label id="description" className="form-label">Примечание</label>
        <input
          id="description"
          className="form-input form-input_last-input"
          type="text"
          value={userDescription}
          onChange={(event) => {
            setUserDescription(event.target.value)
          }}
        />


        <div className="form-controls">
          <button type="button" className="form-button" onClick={cancel}>отменить</button>
          <button type="submit" className="form-button" disabled={!buttonSaveIsActive}
                  style={buttonSaveIsActive ? {} : {color: "grey", borderColor: "grey"}}>сохранить</button>
        </div>
      </form>
    )
  }

  const renderMonth = (monthNumber) => {
    const location = 'ru-RU';
    const event = new Date(0,monthNumber + 1, 0);
    const option = {month: 'long'}
    return event.toLocaleDateString(location, option);
  }

  const Activity = ({createDate, userActivityData, rowData, localId, cancel}) => {
    const [visitData, setVisitData] = useState(null);


    useEffect(() => {
      getVisitData()
    }, []);

    const getVisitData = () => {
      const result = [];
      const user = userActivityData[rowData[localId].tableId];
      const arrayKeys = Object.keys(user).slice(0, 12);
      console.log("user activity data: ", user)

      if (arrayKeys.length !== 1 && arrayKeys[0] !== 'info') {
        arrayKeys.forEach((arrayNumber, index) => {
          result[index] = {};
          result[index].visitNumber = user[index].length
          result[index].month = renderMonth(user.months[index]);
          result[index].visitDates = {};
          
          if (result[index].visitNumber > 0) {
            user[index].forEach((timestamp) => {
              let formattedDate = createDate(timestamp).split(' ').slice(0, -1).join(' ');
              let formattedTime = createDate(timestamp).split(' ').pop();
              let tempKeys = Object.keys(result[index].visitDates);
              
              if (tempKeys.find((key) => key === formattedDate)) {
                result[index].visitDates[formattedDate].push(formattedTime);
              } else {
                result[index].visitDates[formattedDate] = [formattedTime];
              }
            });
          }
        })
        setVisitData(result)
      } else {
        setVisitData(result)
      }
      console.log("visit data: ", result)
    }

    return (
      <div className="activity-container">
        <div className="activity-header-container">
          <h1 style={{margin: "0", fontSize: "2vw", color: "black"}}>АКТИВНОСТЬ ПОЛЬЗОВАТЕЛЯ</h1>
          <button type="button" className="activity-close-button" onClick={cancel}></button>
        </div>

        <h2 style={{margin: "0 0 4vw 0", fontSize: "2vw", color: "grey"}}>
          {rowData[localId].organization}
        </h2>
        <p style={{margin: "0 0 2vw 0", lineHeight: "1.5", fontSize: "2vw"}}>Последний визит <br />
          {createDateOnly(rowData[localId].lastVisit)}</p>

        <div className="activity-data-container">
          <div className="activity-graphic-container">
            {visitData !== null && <Graphic data={visitData}/>}
          </div>

          <div className="activity-table-container">
            <table>
              <tbody>
                {visitData !== null && Array.isArray(visitData) && visitData.length > 0 && <InfoTable data={visitData}/>}
                {Array.isArray(visitData) && visitData.length === 0 && <tr>
                  <td colSpan={2} className="activity-table-no-data">Данные отсутствуют</td>
                </tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }

  const Graphic = ({data}) => {
    return (
      <ResponsiveContainer width={"100%"} height={"100%"} style={{paddingLeft: "1.5vw"}}>
        <BarChart
          width="100%"
          height="100%"
          data={data}
          {...{
            overflow: 'visible'
          }}
          margin={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }}
        >
          {/*<CartesianGrid vertical={false} />*/}
          <XAxis dataKey="month" angle="-45" textAnchor="end" />
          {/*<YAxis*/}
          {/*  type="number"*/}
          {/*  domain={[0, 31]}*/}
          {/*  tickLine={false}*/}
          {/*  axisLine={false}*/}
          {/*/>*/}
          <Legend height="3.5vw"
                  margin={{ top: 0, left: 0, right: 0, bottom: 0 }}
                  chartHeight="50px"
                  wrapperStyle={{ position: 'relative' }}
                  content={<p className="activity-graphic-legend-text">количество посещений</p>}
          />
          <Bar barSize="3%" dataKey="visitNumber" fill="#3cb7ff" label={{ position: 'top', fontWeight: "bold", fill: "rgba(0, 0, 0, 0.9)"}}/>
        </BarChart>
      </ResponsiveContainer>
    )
  }

  const InfoTable = ({data}) => {
    const getRow = (monthData) => {
      let keys = Object.keys(monthData.visitDates);
      return keys.map((date, index) =>
        <tr className="activity-table-month" key={date + index + "tr"}>
          <td key={date + index + "td"} className="activity-table-date">{date}</td>
          {monthData.visitDates[date].map((time, timeIndex) =>
            <tr key={time + timeIndex + "tr"} className="activity-table-date--time-row">
              <td className="activity-table-date activity-table-date--time-cell" key={time + timeIndex + "td"} >{time}</td>
            </tr>)}
        </tr>
      )
    }
    const reversedData = Array.from(data).reverse();
    return reversedData.map((monthData, index) => {
      return <>
        <tr key={monthData.month + index + "tr"}>
          <td colSpan={2} key={monthData.month + index + "td"}
              className={monthData.visitNumber > 0
                ? "activity-table-month"
                : "activity-table-month activity-table-month_no-data"
              }>
            {monthData.month}
          </td>
        </tr>

        {monthData.visitNumber > 0 && getRow(monthData, index)}
      </>
    })
  }

  const SendNotifications = () => {

    const listReadyToOpen = useRef(false);
    const factoriesList = useRef(userRole.roleId === 1 && factories.map(factory => `завод ${factory.factory}`));
    const [chosenUsers, setChosenUsers] = useState([]);
    const refNamesContainer = useRef([]);
    const refInputValues = useRef([]);
    const [usersList, setUsersList] = useState([]);
    const [idList, setIdList] = useState([]);
    const [json, setJson] = useState('');
    const [theme, setTheme] = useState("");
    const [licenceKeysList, setLicenceKeysList] = useState([]);
    const axiosPrivate = useAxiosPrivate();

    const [notifications, setNotifications] = useState([]);
    const notificationList = useRef(null)

    const [allowDataTransfer, setAllowDataTransfer] = useState(false);
  
    const [openKeysList, setOpenKeysList] = useState(false);
    const loadKeysList = openKeysList && licenceKeysList.length === 0;
    const [licenseKey, setLicenseKey] = useState('');

    const [openUsersList, setOpenUsersList] = useState(false);
    const loadUsersList = openUsersList && usersList.length === 0;

    const [chooseAll, setChooseAll] = useState(null);

    const [clearOnChange, setClearOnChange] = useState(false);


    useEffect(() => {
      (async () => {
        await getData();
      })()
    }, []);

    useEffect(() => {
      if (licenseKey !== "" && licenseKey !== null) {
        axiosPrivate.get(`/UserAdministration/Notification/${licenseKey}/9`)
        .then((res) => {
          notificationList.current = res.data
          renderMessages(res.data)
        })
        .catch(e => {
          alert(JSON.stringify(e.response.data.message));
        });
      } else {
        setNotifications("")
      }
    }, [licenseKey])
  
    const getData = async () => {
      await axiosPrivate.get('/Users')
      .then((res) => {
        const data = res.data;
        const enabledOptionsTokens = data.filter(user => {
          return (!(user.deviceToken === null));
        });
        const resultTokens = enabledOptionsTokens.map(user => user.deviceToken);
        setLicenceKeysList(resultTokens);
  
        const enabledOptionsUsers = data.filter(user => {
          return (!(user.name === null));
        });
  
        const resultUsersNames = enabledOptionsUsers.map(user => {
          return user.name;
        });
        setUsersList(resultUsersNames);
  
        const resultIdList = enabledOptionsUsers.map(user => {
          return user.id;
        });
        setIdList(resultIdList);
        listReadyToOpen.current = true;

      })
      .catch( (e) => { console.log("getData error ", e) } );
    };

    const renderMessages = (arr) => {
      const items = arr.map(({id, modelId, tittle, content, dateAdd}, i) => {
        
        const date = new Date(dateAdd),
              addLeadingZero = (num) => num < 10 ? "0" + num : num ,
              year = addLeadingZero(date.getFullYear()),
              month = addLeadingZero(date.getMonth() + 1),
              day = addLeadingZero(date.getDate()),
              hours = addLeadingZero(date.getHours()),
              minutes =addLeadingZero(date.getMinutes()),
              seconds =addLeadingZero(date.getSeconds())

        return (
          <h3
            className="message"
            id={`message-${i}`}
            key={i}
            style={{margin : "0 0 1vw 0"}}
            onClick={onClickNotification}
            >{`${year}-${month}-${day} ${hours}:${minutes}:${seconds}`}</h3>
        )
      })

      setNotifications(items)
    }

    const onClickNotification = (e) => {
      const {title, content} = notificationList.current[parseInt(e.target.id.match(/\d+/))]
      setTheme(title)
      setJson(content)
      document.querySelector("#theme-name").value = title
      document.querySelector("#comment-name").value = content
    }



    const transferDataToUsers = (pathDefinition) => {
      const allRequests = refInputValues.current.map((id, index) => {
        return axiosPrivate.post(`/UserAdministration/${pathDefinition}/${id}`, {"title" : theme, "jsonObject": json})
        .catch(e => {
          console.error(e);
          alert(`Result of data transfer: ${e.message}`);
        })
      });

      Promise.allSettled(allRequests)
        .then((res) => {
          if (licenseKey !== "" && licenseKey !== null) {
            axiosPrivate.get(`/UserAdministration/Notification/${licenseKey}/9/`)
              .then((res) => {
                notificationList.current = res.data
                renderMessages(res.data)
              })
              .catch(e => {
                alert(JSON.stringify(e.response.data.message));
              });
          }
          alert(`Result of data transfer: ${res[0].value.statusText}`)
        })
        .catch(e => {
          // alert(JSON.stringify(e.response.data.message))
          alert("Проверьте поля ввода данных")
        })
    };

    const onChangeInputUsers = (event, newValue) => {
      if (newValue.find(option => option === "Выбрать всех...")) {
        refInputValues.current = [];
        refInputValues.current = idList;
        refNamesContainer.current = [];
        usersList.forEach((value) => refNamesContainer.current.push(value));
        setChosenUsers(refNamesContainer.current);
      }
      else if (newValue.find(option => option.includes('завод'))) {
        let chosenFactoryName = newValue.find(option => option.includes('завод'));
        chosenFactoryName = chosenFactoryName.split(' ').splice(1).join(' ');
        const chosenFactory = factories.find((factory) => factory.factory === chosenFactoryName)
        getUsersByFactoryId(chosenFactory.id)
      }
      else if (newValue) {
        refNamesContainer.current = newValue;
        const matchResults = [];
        for (let i = 0; i < refNamesContainer.current.length; i++) {
          for (let j = 0; j < usersList.length; j++) {
            if (refNamesContainer.current[i] === usersList[j]) {
              matchResults[i] = idList[j];
              break
            }
          }
        }
        refInputValues.current = matchResults;
        setChosenUsers(refNamesContainer.current)
      } else {
        refNamesContainer.current = [];
      }
      refNamesContainer.current.length > 0 ? setAllowDataTransfer(true) : setAllowDataTransfer(false)
    }

    const getUsersByFactoryId = async (chosenFactoryId) => {
      await axiosPrivate.get(`/Users/GetByFactory/${chosenFactoryId}`)
        .then((res) => {
          let data = res.data;
          let newUsers = data.filter(item => {
            if (Array.isArray(item.users)) {
              return item.users
            }
          })
          let array1 = []
          let array2 = []
          newUsers.forEach((company) => {
            company.users.forEach((userObj) => {
              array1.push(userObj.id);
              array2.push(userObj.name);
            })
          })

          array1.forEach(array1Item => !refInputValues.current.includes(array1Item) && refInputValues.current.push(array1Item));
          array2.forEach(array2Item => !refNamesContainer.current.includes(array2Item) && refNamesContainer.current.push(array2Item));



          setChosenUsers(refNamesContainer.current)
          refNamesContainer.current.length > 0 ? setAllowDataTransfer(true) : setAllowDataTransfer(false)
        })
        .catch( (e) => { console.log("getUsersByFactoryId error ", e) } );
    }

    return (
      <div style={{display: "block", width : "100%"}} className="notification-container">
        <div
          style={{position: "relative", margin: "10vw auto 0 auto", display: "flex"}}
          className={listReadyToOpen.current ? "message-container" : "message-container notification-modal"}>
          <div
            style={{margin : "0 0 0 auto", width : "25%", borderRight : "0.1vw solid gray"}}
            className="message-container modal-form">
              <h1 style={{margin : "0 0 1.5vw"}} className="form-header">Последние сообщения</h1>
              <Autocomplete
                disabled={!listReadyToOpen.current}
              className="input-users"
              open={openKeysList}
              value={licenseKey}
              onChange={(event, newValue) => {
                setLicenseKey(newValue)
              }}
              onOpen={() => {
                setOpenKeysList(true);
              }}
              onClose={() => {
                setOpenKeysList(false);
              }}
              freeSolo
              forcePopupIcon={true}
              isOptionEqualToValue={(option, value) => option.key === value.key}
              getOptionLabel={(option) => typeof option === 'string'
              || option instanceof String ? option : ""}
              options={licenceKeysList}
              loading={loadKeysList}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="License key"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadKeysList ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
            <div style={{width: "100%", display: "flex", flexDirection: "column", alignItems: "center"}}>
              {notifications}
            </div>
          </div>



          <form
            style={{position: "relative", padding : "2vw", margin : "0 auto 0 0", borderLeft : "0"}}
            id="form-add-company"
            className="modal-form">
              <h1  className="form-header">Новое сообщение</h1>

              <Autocomplete
                  disabled={!listReadyToOpen.current}
                  multiple
                  limitTags={3}
                  className="input-users"
                  id="send-notification-users"
                  open={openUsersList}
                  value={chosenUsers}  // refNamesContainer.current
                  disableCloseOnSelect
                  // getOptionDisabled={(option) => {
                  //   return option === "Выбрать всех..." || option === "завод veon"
                  // }}
                  filterOptions={(options, params) => {
                    if (userRole.roleId === 1 && loadUsersList === false) {
                      const filter = createFilterOptions();
                      const filtered = filter(options, params);
                      // return ['Выбрать всех...', ...factoriesList, ...filtered]
                      return ['Выбрать всех...', ...factoriesList.current, ...filtered]
                    } else {
                      const filter = createFilterOptions();
                      const filtered = filter(options, params);
                      return [...filtered]
                    }
                  }}
                  onChange={(e, newValue) => {
                    onChangeInputUsers(e, newValue)
                  }}
                  onOpen={() => {
                    setOpenUsersList(true);
                  }}
                  onClose={() => {
                    setOpenUsersList(false);
                  }}
                  freeSolo
                  forcePopupIcon={true}
                  options={usersList}
                  loading={loadUsersList}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      style={{fontSize : "2vw"}}
                      placeholder="Получатели"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {loadUsersList ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />

              <input
                id="theme-name"
                name="theme"
                type="text"
                autoFocus={false} required={true}
                className="form-input"
                placeholder="Тема"
                defaultValue={theme}
                onChange={e => {setTheme(e.target.value)}}
              />

              <textarea
                id="comment-name"
                name="comment"
                type="text"
                className="form-input"
                defaultValue={json}
                style={{resize : "none", fontSize : "1.5vw", minHeight : "20vh"}}
                onChange={e => {setJson(e.target.value)}}
              />

              <div style={{width : "100%",display : "flex", justifyContent : "right"}}>
                <button
                  type="submit"
                  className="form-button"
                  disabled={!allowDataTransfer}
                  style={allowDataTransfer ? {} : {color: "grey", borderColor: "grey"}}
                  onClick={(e) => {e.preventDefault(); transferDataToUsers("Notification")}}
                  >Отправить</button>      
              </div>
              <button type="button" style={{position : "absolute", right : "0", margin : "0 2vw 0 0"}} className="activity-close-button" onClick={cancel}/>

          </form>
          <div
            className={listReadyToOpen.current ? "" : "modal-loader"}
            style={listReadyToOpen.current ? {display: "none"} : {}}
          >
            <CircularProgress color="info" size={50} />
          </div>
        </div>
      </div>
    )
  }

  const FactoryActivity = ({cancel}) => {
    const graphicReadyToOpen = useRef(null);
    const [factoryActivity, setFactoryActivity] = useState({});
    const [visitFactoryData, setVisitFactoryData] = useState({});
    const [factoryList, setFactoryList] = useState([]);
    const [openTabName, setOpenTabName] = useState('');
    const [dataForView, setDataForView] = useState({});


    useEffect (() => {
      getFactoryActivity();
    },[])

    useEffect(() => {
      prepareFactoriesDataSet(factoryActivity)
    }, [factoryActivity]);

    useEffect(() => {
      if (Object.keys(visitFactoryData).length > 0 && openTabName !== '') {
        prepareFactoryDataForView(openTabName);
      }
    }, [visitFactoryData, openTabName]);

    const getFactoryActivity = async () => {
      await axiosPrivate.get(`/UserAdministration/FactoryActivities`)
        .then((res) => {
          setFactoryActivity(res.data);
          console.log("FACTORY DATA: ", res.data)
          setFactoryList(Object.keys(res.data));
          setOpenTabName(Object.keys(res.data)[0]);
        })
        .catch(e => {
          alert(JSON.stringify(e.response.data.message));
        });
    }

    const prepareFactoriesDataSet = (factoryActivity) => {
      let prepFactoryDataSetResult = {};
      let currentMonth = new Date().getMonth();
      let currentYear = new Date().getFullYear();
      let referenceDate = null;

      if (currentMonth < 11) {
        referenceDate = new Date(currentYear - 1, currentMonth + 1, 1, 0, 0, 0, 0);
      } else {
        referenceDate = new Date(currentYear, 0, 1, 0, 0, 0, 0);
      }

      factoryList.forEach((factoryName, index) => {
        let currentFactoryDatesArray = factoryActivity[factoryName];
        if (currentFactoryDatesArray.length > 0) {
          const sortedDates = currentFactoryDatesArray.sort((a, b) => new Date(a) - new Date(b));
          const periodDates = sortedDates.filter((currentArrayDate) => {
            return new Date(currentArrayDate) >= referenceDate;
          })

          let factoryName =  factoryList[index];
          prepFactoryDataSetResult[factoryName] = {};
          prepFactoryDataSetResult[factoryName].info = false;
          prepFactoryDataSetResult[factoryName].months = [];
          let monthNumber = new Date(referenceDate).getMonth();
          for (let i = 0; i < 12; i++) {
            if (monthNumber > 11) {
              monthNumber = 0;
            }
            prepFactoryDataSetResult[factoryName].months[i] = monthNumber;
            monthNumber++;
          }

          prepFactoryDataSetResult[factoryName].months.forEach((monthIndex, index) => {
            prepFactoryDataSetResult[factoryName][index] = periodDates.filter((date) => {
              return new Date(date).getMonth() === monthIndex;
            })
          })
        } else {
          let factoryName = factoryList[index];
          prepFactoryDataSetResult[factoryName] = {};
          prepFactoryDataSetResult[factoryName].info = "Активности не было";
        }
      })
      setVisitFactoryData(prepFactoryDataSetResult)
    }


    const prepareFactoryDataForView = (factoryName) => {
      const result = [];
      const arrayKeys = Object.keys(visitFactoryData[factoryName]).slice(0, 12);

      if (arrayKeys.length !== 1 && arrayKeys[0]) {
        arrayKeys.forEach((arrayNumber, index) => {
          result[index] = {};
          result[index].visitNumber = visitFactoryData[factoryName][index].length;
          result[index].month = renderMonth(visitFactoryData[factoryName].months[index]);
          result[index].visitDates = {};
          if (result[index].visitNumber > 0) {
            visitFactoryData[factoryName][index].forEach((date) => {
              let tempDate = new Date(date).toLocaleDateString()
              let tempTime = new Date(date).toLocaleTimeString();
              let tempKeys = Object.keys(result[index].visitDates)

              if (tempKeys.find((key) => key === tempDate)) {
                result[index].visitDates[tempDate].push(tempTime)
              } else {
                result[index].visitDates[tempDate] = [tempTime]
              }
            })
          } else {
            result[index].visitDates = false;
          }

          setDataForView(result);
        })
        } else {
          setDataForView(result);
        }
      graphicReadyToOpen.current = true;
    }

    return (
      <div className="activity-container">
        <div className="activity-header-container">
          <h1 style={{margin: "0", fontSize: "2vw", color: "black"}}>АКТИВНОСТЬ ЗАВОДОВ</h1>
          <button type="button" className="activity-close-button" onClick={cancel}></button>
        </div>

        <ul className="activity-tabs-panel">
          {factoryList.length > 0 && factoryList.map((factoryName, index) => {
            return <button key={factoryName + index + "button"} className={openTabName === factoryName ? "activity-tab-button activity-tab-button--active" : "activity-tab-button"} value={factoryName} onClick={() => {
              setOpenTabName(factoryName)
            }}>{factoryName}</button>
          })}
        </ul>

        <h2 style={{margin: "0 0 2vw 0", fontSize: "2vw", color: "grey"}}>
          {openTabName}
        </h2>

        <p style={{margin: "0 0 2vw 0", lineHeight: "1.5", fontSize: "2vw"}}>Последний визит <br />
          {graphicReadyToOpen.current &&
            (() => {
              let arrayKeys = Object.keys(dataForView[dataForView.length - 1].visitDates);
              if (arrayKeys.length !== 0) {
                let date = arrayKeys[arrayKeys.length - 1]
                let arrayTimeData = dataForView[dataForView.length - 1].visitDates[date]
                let time = arrayTimeData[arrayTimeData.length -1]
                return `${date} в ${time}`
              } else {
                return "Нет данных"
              }
            })()
          }
        </p>

        <div className="activity-data-container">
          <div className="activity-graphic-container">
            {graphicReadyToOpen.current && <Graphic data={dataForView} />}
          </div>

          <div className="activity-table-container">
            <table>
              <tbody>
              {graphicReadyToOpen.current && <InfoTableFactory data={dataForView}/>}
              {Object.keys(visitFactoryData).length === 0 && <tr>
                <td colSpan={2} className="activity-table-no-data">Данные отсутствуют</td>
              </tr>}
              </tbody>
            </table>
          </div>
        </div>
        {/*<div*/}
        {/*  className={graphicReadyToOpen.current ? "" : "modal-loader"}*/}
        {/*  style={graphicReadyToOpen.current ? {display: "none"} : {}}*/}
        {/*>*/}
        {/*  <CircularProgress color="info" size={50} />*/}
        {/*</div>*/}
      </div>
    )
  }

  const InfoTableFactory = ({data}) => {
    const getRow = (monthData) => {
      let keys = Object.keys(monthData.visitDates);
      return keys.map((date, index) =>
        <tr className="activity-table-month" key={date + index + "tr"}>
          <td key={date + index + "td"} className="activity-table-date">{date}</td>
          {monthData.visitDates[date].map((time, index) =>
            <tr key={time + index + "tr"} className="activity-table-date--time-row">
              <td className="activity-table-date activity-table-date--time-cell" key={time + index + "td"} >{time}</td>
            </tr>)}
        </tr>
      )
    }

    let reversedData = Array.from(data).reverse();
    return reversedData.map((monthData, index) => {
      return <>
        <tr key={monthData.month + index + "tr"}>
          <td colSpan={2} key={monthData.month + index + "td"}
              className={monthData.visitNumber > 0
                ? "activity-table-month"
                : "activity-table-month activity-table-month_no-data"
              }>
            {monthData.month}
          </td>
        </tr>

        {monthData.visitNumber > 0 && getRow(monthData, index)}
      </>
    })
  }

  const finalResult = () => {
    return (
      <Modal
        open={modalType !== '' && true}
        onClose={() => cancel()}
        className="modal-container"
      >
        <>
          {chooseModal.addFactory && <AddFactory setCurrentFactory={setCurrentFactory} currentFactory={currentFactory} factories={factories} cancel={cancel} />}
          {chooseModal.editFactory && <EditFactory setCurrentFactory={setCurrentFactory} currentFactoryData={currentFactoryData} currentFactory={currentFactory} cancel={cancel} />}
          {chooseModal.sendNotifications && <SendNotifications cancel={cancel} />}
          {chooseModal.factoryActivity && <FactoryActivity cancel={cancel} />}
          {chooseModal.addCompany && <AddCompany cancel={cancel} />}
          {chooseModal.addUser && <AddUser rowData={rowData} cancel={cancel} companies={companies}/>}
          {chooseModal.editCompany &&
            <EditCompany companies={companies} localId={localId} rowData={rowData} cancel={cancel} />}
          {chooseModal.editUser && <EditUser rowData={rowData} localId={localId} cancel={cancel}/>}
          {chooseModal.activity && <Activity createDate={createDate} createDateOnly={createDateOnly} userActivityData={userActivityData} localId={localId} rowData={rowData} cancel={cancel} />}
        </>
      </Modal>
    )
  }

  return ReactDOM.createPortal(finalResult(), portal)
}
